import React from "react"
import { Link } from 'react-router-dom';

import Logoimg from '../../../assets/images/logo-white.png';

const Logo = () => {
    return (
        <Link to="/"><img src={Logoimg} alt="Skycars" /></Link>     
    );
  }
  
  export default Logo;